import type { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Anchor,
    Body1,
    Flex,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { DigitallyReceivedPrescriberOrderInfoFragment } from '../../../graphql/generated/graphql';
import type { NdcDefinition } from '../../../types/drug-config';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

export type SwitchToCashLinkProps = {
    ndcDefinition: NdcDefinition;
    order: DigitallyReceivedPrescriberOrderInfoFragment;
};

export const SwitchToCashLink: FC<SwitchToCashLinkProps> = ({
    ndcDefinition,
    order,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleSwitchClick = (e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        navigate(
            getAbsoluteRoute('order.prescriberOrderId.switch.root', {
                prescriberOrderId: order?.drxId ?? '',
            })
        );
    };

    if (ndcDefinition.alternateConfigs.length === 0) {
        return null;
    }

    return (
        <Stack gap={0}>
            <Body1 bold highContrast>
                {t('previewDetails.switchToCash.text')}
            </Body1>

            <Anchor
                onClick={handleSwitchClick}
                textDecoration="none"
                display="inline-flex"
            >
                <Flex gap="xxxs">
                    {/* oxlint-disable-next-line jsx-a11y/alt-text -- tracked in docs/oxlint-violations.md */}
                    <img
                        src="/static/img/vial-icon.svg"
                        aria-hidden="true"
                        height="21"
                        width="21"
                    />
                    <Body1 color="primary" bold>
                        {t('previewDetails.switchToCash.link')}
                    </Body1>
                </Flex>
            </Anchor>
        </Stack>
    );
};
